/* tslint:disable */
/* eslint-disable */
/**
 * Sports App Training Plans
 * API for the Sports App Training Plans
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EquipmentConfig
 */
export interface EquipmentConfig {
    /**
     * 
     * @type {string}
     * @memberof EquipmentConfig
     */
    equipmentId: string;
    /**
     * 
     * @type {boolean}
     * @memberof EquipmentConfig
     */
    optional: boolean;
}

/**
 * Check if a given object implements the EquipmentConfig interface.
 */
export function instanceOfEquipmentConfig(value: object): value is EquipmentConfig {
    if (!('equipmentId' in value) || value['equipmentId'] === undefined) return false;
    if (!('optional' in value) || value['optional'] === undefined) return false;
    return true;
}

export function EquipmentConfigFromJSON(json: any): EquipmentConfig {
    return EquipmentConfigFromJSONTyped(json, false);
}

export function EquipmentConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): EquipmentConfig {
    if (json == null) {
        return json;
    }
    return {
        
        'equipmentId': json['equipmentId'],
        'optional': json['optional'],
    };
}

export function EquipmentConfigToJSON(json: any): EquipmentConfig {
    return EquipmentConfigToJSONTyped(json, false);
}

export function EquipmentConfigToJSONTyped(value?: EquipmentConfig | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'equipmentId': value['equipmentId'],
        'optional': value['optional'],
    };
}

